window.Conversations = {
    setupDashboardEvents() {
        this.handleLoadMoreConversations('.show-more-conversations');
        this.handleFilters();
    },

    handleFilters() {
        const filterButtons = document.querySelectorAll('.filter-button');
        filterButtons.forEach(function (button) {
            if (button) {
                button.addEventListener('click', () => {
                    filterButtons.forEach(b => b.classList.remove('active'));
                    button.classList.add('active');

                    const value = button.dataset.dealId;
                    Conversations.filterByDeal(value || null);
                });
            }
        });

        const params = new URL(window.location.href).searchParams;
        const selectedId = params.get('deal_id');
        const initialButton = selectedId
            ? document.querySelector(`.filter-button[data-deal-id="${selectedId}"]`)
            : document.querySelector(`.filter-button[data-deal-id=""]`);
        if (initialButton) {
            filterButtons.forEach(b => b.classList.remove('active'));
            initialButton.classList.add('active');
        }
    },

    filterByDeal(dealId) {
        const url = new URL(window.location.href);
        const params = url.searchParams;
        if (dealId) {
            url.searchParams.set('deal_id', dealId);
        } else {
            url.searchParams.delete('deal_id');
        }

        window.history.replaceState({}, '', url.toString());

        $.ajax({
            url: '/conversations',
            method: 'GET',
            data: params.toString()
        });
    },

    handleLoadMoreConversations(loadMoreElementId) {
        $(document).on('click', loadMoreElementId, function (e) {
            e.preventDefault();

            var nextPage = $(this).data('next-page') || 2;
            let enterprise_team_id = $('#enterprise_team_id').val();
            let filter_team_id = $('#filter_team_id').val();
            let data = {
                ['page']: nextPage,
                enterprise_team_id: enterprise_team_id,
                filter_team_id: filter_team_id
            }

            $.ajax({
                url: '/conversations/load_more_conversations',
                type: 'GET',
                data: data,
                dataType: 'script'
            });
        });
    },

    setupConversationSearch() {
        $('#conversation-search').on('keydown', function (e) {
            if (e.key === 'Enter' || e.which === 13) {
                e.preventDefault();
                handleEnterSearch();
            }
        });

        $('#conversation-search').on('input', function () {
            var value = this.value.trim();
            if (value.length === 0) {
                $('#conversations-container').show();
                $('#search-results-container').hide();
            }
        });

        function handleEnterSearch() {
            var inputSearch = document.getElementById('conversation-search');
            var query = inputSearch.value.trim().toUpperCase();
            if (query.length > 0) {
                Conversations.searchConversations(query);
            } else {
                $('#conversations-container').show();
                $('#search-results-container').hide();
            }
        }
    },

    searchConversations(query) {
        $.ajax({
            url: '/conversations/search',
            type: 'GET',
            data: {query: query},
            dataType: 'script'
        });
    },

    enterpriseCompanyChange() {
        $(".enterprise-bar-dropdown").change(function (e) {
            let selectedId = $(this).find("option:selected").val();
            window.location.href = '/conversations?enterprise_team_id=' + selectedId;
        });
    },

    showConversations() {
        const showConversationButtons = document.querySelectorAll('.show-conversation-btn');
        showConversationButtons.forEach(function (button) {
            if (button) {
                button.addEventListener('click', () => {
                    const conversationId = button.dataset.conversationId;
                    const externalId = button.dataset.externalId;
                    const enterpriseTeamId = button.dataset.enterpriseTeamId;
                    if (conversationId && externalId) {
                        Conversations.openConversation(conversationId, externalId, enterpriseTeamId);
                    }
                });
            }
        });
    },

    openConversation(conversationId, externalId, enterpriseTeamId) {
        const master = $('.split-screen-main-panel');
        const panel = $('.split-screen-detail-panel');
        let url = `/conversations/${conversationId}`;
        if (enterpriseTeamId !== undefined && enterpriseTeamId !== null && enterpriseTeamId !== '') {
            url = url + `?enterprise_team_id=${enterpriseTeamId}`;
        }

        $.ajax({
            url: url,
            method: 'GET',
            headers: {'X-Requested-With': 'XMLHttpRequest'},
            success: function (html) {
                panel.html(html);
                master.addClass('split-open');
                panel.addClass('split-open');

                SendbirdConversation.init(conversationId, externalId);

                const selectedPreview = document.getElementById(`conversation-preview-${externalId}`);
                if (selectedPreview && typeof selectedPreview.scrollIntoView === 'function') {
                    selectedPreview.scrollIntoView({behavior: 'smooth', block: 'center'});
                }

                const conversationPreviews = document.querySelectorAll('.conversation-preview');
                conversationPreviews.forEach(preview => {
                    if (preview.id !== `conversation-preview-${externalId}`) {
                        preview.style.backgroundColor = '#ffffff';
                    } else {
                        preview.style.backgroundColor = '#EEF8FE';
                    }
                });

                $(document).on('click', '.close-conversation-btn', function (e) {
                    Conversations.closeConversationPanel(externalId);
                });
            },
            error: function () {
            }
        });
    },

    closeConversationPanel(externalId) {
        const master = $('.split-screen-main-panel');
        const panel = $('.split-screen-detail-panel');
        master.removeClass('split-open');
        panel.removeClass('split-open');

        SendbirdConversation.destroy();

        panel.empty();

        const conversationPreview = document.getElementById(`conversation-preview-${externalId}`);
        conversationPreview.style.backgroundColor = '#ffffff';
    },

    validateUsersForm(formName) {
        $(formName).validate({
            rules: {
                'conversation[user_ids][]': {
                    required: true
                }
            },
            messages: {
                'conversation[user_ids][]': {
                    required: "Please select at least one user"
                }
            },
            errorPlacement: function (error, element) {
                error.insertAfter(element.parent().parent());
            }
        });
    }
}
